import { Button, Component, Node, ScrollView, _decorator } from 'cc';
import Lobby from '../../../System/Lobby';
import JackpotRecord from '../GameObject/JackpotRecordBar/JackpotRecord';
import Page from '../../../../common/scripts/Toolkit/Components/Page/Page';
import InfiniteScrollView from '../../../../common/scripts/Toolkit/Components/ScrollView/InfiniteScrollView';
import DataType from '../../../../tableEngine/Script/Game/Data/Config/DataStructure';
import NodeName from '../../Data/Config/SceneNodeName';

const { ccclass, property, requireComponent } = _decorator;

@ccclass('JackpotRecordPage')
@requireComponent(Page)
export default class JackpotRecordPage extends Component {
    @property(InfiniteScrollView)
    private readonly scrollView: InfiniteScrollView = null;

    @property(Button)
    private readonly menuButton: Button = null;

    @property(Button)
    private readonly returnButton: Button = null;

    @property
    private readonly maxDisplayCount = 50;

    public isReturnToMenuPage: boolean = true;
    private _page: Page = null;
    private _menuPage: Page = null;
    private _scrollViewComponent: ScrollView = null;
    private _displayedRecords: Readonly<DataType.Jackpot.WinRecordData[]> = [];
    private _itemJackpotRecordMap: Map<Node, JackpotRecord> = new Map();

    private get page() {
        if (!this._page) {
            this._page = this.node.getComponent(Page);
        }
        return this._page;
    }

    private get menuPage() {
        if (!this._menuPage) {
            this._menuPage = Lobby.scene.getNode(NodeName.LobbyMenuPage).getComponent(Page);
        }
        return this._menuPage;
    }

    private get scrollViewComponent() {
        if (!this._scrollViewComponent) {
            this._scrollViewComponent = this.scrollView.getComponent(ScrollView);
        }
        return this._scrollViewComponent;
    }

    protected onLoad() {
        this.page.on(Page.EVENT_TYPE.OPEN_START, async () => {
            this.scrollViewComponent.stopAutoScroll();
            this.scrollViewComponent.scrollToTop();
            await Lobby.jackpot.syncLatestWinRecords();
            this._displayedRecords = Lobby.jackpot.getWinRecords().slice(0, this.maxDisplayCount);
            this._updateContent();
            this.scrollViewComponent.stopAutoScroll();
            this.scrollViewComponent.scrollToTop();
        });
        this.scrollView.on(InfiniteScrollView.EVENT_TYPE.FIRST_ITEM_INDEX_CHANGED, this._updateContent, this);
        this.scrollView.node.on(ScrollView.EventType.SCROLL_TO_BOTTOM, () => Lobby.jackpot.requestNewJackpotWinRecord());
        this.returnButton.on(Button.EventType.CLICK, () => {
            this.isReturnToMenuPage = false;
        });
        this.menuButton?.on(Button.EventType.CLICK, () => {
            Lobby.audio.pauseMusic(1);
            Lobby.audio.resumeMusic(0);
            this.page.close();
            this.isReturnToMenuPage = true;
        });
    }

    private _updateContent() {
        this.scrollView.itemCount = this._displayedRecords.length;
        this.scrollView.itemGenerator.items.forEach((item, index) => {
            let jackpotRecord = this._itemJackpotRecordMap.get(item);
            if (!jackpotRecord) {
                jackpotRecord = item.getComponent(JackpotRecord);
                this._itemJackpotRecordMap.set(item, jackpotRecord);
            }
            const data = this._displayedRecords[index + this.scrollView.firstItemIndex];
            if (data) {
                jackpotRecord.display(data);
            }
            jackpotRecord.node.active = !!data;
        });
    }
}
